import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { OrderModel } from '../models/order.model';
import { OrderCustomerAccountModel } from '../models/order-customer-account.model';

export class OrderCustomerAccountsApiService extends ApiService {
  static endpoint = 'orders/{order_id}/customer-accounts';

  /**
   * @param {Number|null} customerAccountId
   * @return {String}
   * @protected
   */
  static buildOrderDiscountUrl(orderId, customerAccountId = null) {
    return this.buildUrl(customerAccountId).replace('{order_id}', orderId);
  }

  /**
   * @param {String|Number} orderId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderCustomerAccountModel>>}
   * @public
   */
  static async getAll(orderId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildOrderDiscountUrl(orderId), {
      ...config,
      dataModel: OrderCustomerAccountModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} orderId
   * @param {String|Number} customerAccountId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderCustomerAccountModel>>}
   * @public
   */
  static async get(orderId, customerAccountId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildOrderDiscountUrl(orderId, customerAccountId), {
      ...config,
      dataModel: OrderCustomerAccountModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} orderId
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderModel>>}
   * @public
   */
  static async post(orderId, data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildOrderDiscountUrl(orderId), data, {
      ...config,
      dataModel: OrderModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} orderId
   * @param {String|Number} customerAccountId
   * @param {Object} config
   * @return {Promise<HttpResponse>}
   * @public
   */
  static async delete(orderId, customerAccountId, config = {}) {
    return HttpApiClient.delete(this.buildOrderDiscountUrl(orderId, customerAccountId), { ...config });
  }
}
